module.exports = __webpack_public_path__ + "static/media/awesomesolos.bdc0a30f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/awesomesolos.gif
// module id = 236
// module chunks = 0